module.exports = __webpack_public_path__ + "static/media/mountadex-combined-macbook.744e7384.png";